import gql from 'graphql-tag';

const IMPORT_CATEGORIES_FROM_LIBRARY_MUTATION = gql`
  mutation importCategoriesFromLibrary($input: [CategoryImportInput]) {
    importCategoriesFromLibrary(input: $input)
  }
`;

export default IMPORT_CATEGORIES_FROM_LIBRARY_MUTATION;
